export {default as OfferBanner} from "./OfferBanner";
export type {OfferBannerProps} from "./OfferBanner.props";
